import { useEffect } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'

import { resetOrdinaryPermission } from 'quick-quote/product-common/validate-permission/actions'

import { BasicPlanSummary } from './basic-plan-summary'

export const _OrdinaryBasicPlan = function(props) {
  const { displayProduct, isSelected, cssClass, validateProduct, disabled, linkPath, resetOrdinaryPermission } = props
  const history = useHistory()
  useEffect(() => {
    return () => {
      if (['PUSH', 'REPLACE'].includes(history.action)) {
        resetOrdinaryPermission()
      }
    }
  }, [])

  return (
    <div
      key={displayProduct.code}
      className={['product', cssClass, isSelected ? 'selected' : '', disabled ? 'disabled' : ''].join(' ')}
      data-product-name={displayProduct.displayName}
      data-product-code={displayProduct.code}
      onClick={() => !disabled && validateProduct(displayProduct, linkPath)}
    >
      <div className="product-card-container">
        <BasicPlanSummary displayProduct={displayProduct} isSelected={isSelected} />
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  return {
    displayProduct: props.displayProduct,
    isSelected: props.isSelected,
    cssClass: props.cssClass,
    validateProduct: props.validateProduct,
    proceedToOrdinaryProduct: state.permissionOrdinary.proceedToOrdinaryProduct,
  }
}

export const OrdinaryBasicPlan = connect(mapStateToProps, (dispatch) => ({
  resetOrdinaryPermission: bindActionCreators(resetOrdinaryPermission, dispatch),
}))(_OrdinaryBasicPlan)
